// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"to_a bih_b bih_bj","SubscribedPhotoblogs__link":"to_b bih_a bih_r"};